import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import TokenService from 'services/tokenService';


interface SecureRouteProps extends RouteProps {
  component?: React.ComponentType<any>;
  children?: React.ReactNode;
  [key: string]: any;
}

const SecureRoute: React.FC<SecureRouteProps> = ({ component: Component, children, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!TokenService.getUser()) { return <Redirect to='/login' />; }
        if (Component) { return <Component {...props} {...rest} />; }
        return children;
      }}
    />
  );
};

export default SecureRoute;